import {ApiRes} from '../../types/api'
import {apiGet, API_URL} from '../api'

export interface IReferrals {
    exchange: string
    referral_code: string
    status: number
    exchange_maker_fee_rate: number
    exchange_taker_fee_rate: number
    id: number
    max_maker_fee_rate: number
    max_reward_rate: number
    max_taker_fee_rate: number
}

export const getReferrals = async (): Promise<ApiRes<IReferrals[]>> => {
    return await apiGet(API_URL, `admin/exchange/referrals`)
}
